import { Injectable, resource, signal } from '@angular/core';
import { Bestyrelsesmedlem } from '@features/letpensiondk/letpensiondk-bestyrelse/bestyrelsesmedlem.model';
import { RestDatasource } from '@core/api/rest.datasource';
import { BestyrelseSearchParams } from '@features/letpensiondk/letpensiondk-bestyrelse/bestyrelse-search-params.model';

@Injectable({
  providedIn: 'root',
})
export class BestyrelseDatasource extends RestDatasource<Bestyrelsesmedlem> {
  override endpoint = '/api/admin/bestyrelse';

  searchParams = signal<BestyrelseSearchParams>({
    text: '',
    medtagSlettede: false,
  });

  override data = resource({
    params: () => this.searchParams(),
    loader: async ({ params, abortSignal }) => {
      return await this.getList(
        {
          filter: JSON.stringify(params),
          sortBy: 'sekvensNr',
        },
        abortSignal
      );
    },
  });
}
